import { FormInstance } from "antd/es/form"
import { styled } from "styled-components"
import { theme } from "src/global/ui/themes/theme.ts"
import { ExpectationPromptBox } from "src/pages/DataAssets/views/Expectations/SimpleExpectationDrawer/ExpectationPrompt/ExpectationPromptBox"
import { GenerateExpectationButton } from "src/pages/DataAssets/views/Expectations/SimpleExpectationDrawer/ExpectationPrompt/GenerateExpectationButton"

const StyledPromptSection = styled.div`
  margin-bottom: ${theme.spacing.s};
  background-color: ${theme.colors.neutralColorPalette.whites.white};
`

type Props = {
  form: FormInstance
  promptText: string
  setPromptText: (text: string) => void
  expectAiError: string | null
  isGeneratingExpectation: boolean
  onGenerateSQL: () => void
}

export function ExpectationPrompt({
  form,
  promptText,
  setPromptText,
  expectAiError,
  isGeneratingExpectation,
  onGenerateSQL,
}: Props) {
  return (
    <StyledPromptSection>
      <ExpectationPromptBox
        form={form}
        promptText={promptText}
        setPromptText={setPromptText}
        expectAiError={expectAiError}
        isGeneratingExpectation={isGeneratingExpectation}
      />
      <GenerateExpectationButton
        onClick={onGenerateSQL}
        disabled={isGeneratingExpectation}
        loading={isGeneratingExpectation}
      />
    </StyledPromptSection>
  )
}
